import { SearchRounded } from "@mui/icons-material";
import { Enterprise } from "../../../../domain/models/enterprise";
import { FormControl, FormHelperText, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import { EnterpriseViewer } from "./enterprise_viewer";

/**
 * ConfigureLoginStepOne
 */

type Props = {
  search: string,
  filteredEnterprise: Enterprise[],
  onSearchChange?: (search: string) => void,
  onClick?: (selectedEnterprise: Enterprise) => void,
};

export const ConfigureLoginStepOne = ({
  search,
  filteredEnterprise,
  onSearchChange,
  onClick,
}: Props) => {
  return (
    <>
      <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
        <h1 className="text-3xl font-semibold">
          Qual é o nome da sua empresa?
        </h1>
        <p className="text-sm font-regular">
          Digite pelo menos os dois primeiros caracteres do nome da sua empresa e selecione a opção correspondente
        </p>
      </div>
      <div className="w-full flex gap-4 flex-col items-center justify-center mt-16">
        <div className="w-full">
          <h1 className="text-black dark:text-white font-semibold">Informe os dados abaixo:</h1>
        </div>

        <FormControl sx={{ width: '100%' }} variant="outlined" size="small">
          <InputLabel htmlFor="search-field">Pesquisar</InputLabel>
          <OutlinedInput
            id="search-field"
            endAdornment={
              <InputAdornment position="end">
                <SearchRounded />
              </InputAdornment>
            }
            label="Pesquisar"
            size="small"
            value={search}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onSearchChange?.(event.target.value)}
            aria-describedby="component-error-text"
            fullWidth
          />
          <FormHelperText id="component-error-text">Ex: Digite "Gdol"</FormHelperText>
        </FormControl>

        <div className="w-full">
          {
            filteredEnterprise.map((enterprise) => (
              <EnterpriseViewer
                key={enterprise.id}
                enterprise={enterprise}
                onClick={onClick} />
            ))
          }
          {
            (search.length > 2 && filteredEnterprise.length === 0) &&
            <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4 justify-center items-center">
              <h1 className="text-xl font-medium">
                Nenhuma empresa encontrada...
              </h1>
            </div>
          }
        </div>
      </div>
      <div className="w-full flex justify-end my-10"></div>
    </>
  );
};